// AdditionOfProductsMealTask.js
// Zasada dodawania + mnożenia — dwa rozłączne warianty: zestaw mięsny lub wegański

import React from 'react';
import { InlineMath, BlockMath } from 'react-katex';
import FractionInput from '../../../../components/inputs/FractionInput';

// ==== GENERATOR ====
// mięsny: zupy 3–6, dania 4–8
// wegański: zupy 2–4, dania 3–6
export function generateTask() {
  const meatSoups = Math.floor(Math.random() * 4) + 3;   // 3..6
  const meatMains = Math.floor(Math.random() * 5) + 4;   // 4..8
  const vegSoups  = Math.floor(Math.random() * 3) + 2;   // 2..4
  const vegMains  = Math.floor(Math.random() * 4) + 3;   // 3..6

  const meatWays = meatSoups * meatMains;
  const vegWays  = vegSoups  * vegMains;
  const answer   = meatWays + vegWays;

  return {
    type: 'AdditionOfProductsMealTask',
    data: { meatSoups, meatMains, vegSoups, vegMains, meatWays, vegWays, answer },
  };
}

// ==== RENDER ====
export function renderTask({ data }) {
  const { meatSoups, meatMains, vegSoups, vegMains } = data;
  return (
    <div style={{ textAlign: 'left' }}>
      <p>
        W stołówce są dwa rodzaje zestawów obiadowych (wybieramy dokładnie <strong>jeden</strong>):
      </p>
      <ul>
        <li>
          <strong>Zestaw mięsny:</strong> zupy:&nbsp;
          <InlineMath math={String(meatSoups)} />;&nbsp; drugie dania:&nbsp;
          <InlineMath math={String(meatMains)} />.
        </li>
        <li>
          <strong>Zestaw wegański:</strong> zupy:&nbsp;
          <InlineMath math={String(vegSoups)} />;&nbsp; drugie dania:&nbsp;
          <InlineMath math={String(vegMains)} />.
        </li>
      </ul>
      <p>Na ile sposobów można wybrać obiad?</p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="" // podgląd bez prefiksu/znaku "="
      placeholder="Wpisz liczbę sposobów"
    />
  );
}

// ==== ODP ====
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== 'object') {
    return { correct: false, message: 'Podaj liczbę.' };
  }
  const given = parseInt(userAnswer.raw, 10);
  if (Number.isNaN(given)) {
    return { correct: false, message: 'Podaj liczbę całkowitą.' };
  }
  const correct = given === data.answer;
  userAnswer.correctAnswer = data.answer;
  return { correct, message: correct ? 'Dobrze!' : 'Spróbuj ponownie.' };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`${data.answer}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== 'object' || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`${userAnswer.raw}`} />;
}

// ==== WYJAŚNIENIE ====
export function renderExplanation({ data }) {
  const { meatSoups, meatMains, vegSoups, vegMains, meatWays, vegWays, answer } = data;
  return (
    <div style={{ textAlign: 'left', lineHeight: 1.7 }}>
      <p><strong>Krok 1. (mnożenie w wariantach)</strong> W każdym wariancie stosujemy zasadę mnożenia:</p>
      <ul>
        <li>Mięsny: <BlockMath math={`${meatSoups} \\cdot ${meatMains} = ${meatWays}`} /></li>
        <li>Wegański: <BlockMath math={`${vegSoups} \\cdot ${vegMains} = ${vegWays}`} /></li>
      </ul>
      <p><strong>Krok 2. (dodawanie wariantów rozłącznych)</strong> Sumujemy, bo wybieramy dokładnie jeden wariant:</p>
      <BlockMath math={`${meatWays} + ${vegWays} = ${answer}`} />
    </div>
  );
}
